import React from 'react';

import { createRoot } from 'react-dom/client';

import { advtPerformance } from '@schibsted-nmp/advertising-events';

import { AdSwitchComponent, AdSwitchProps } from './adSwitch/AdSwitchComponent';

export function renderAd(props: AdSwitchProps) {
  advtPerformance.markXandrEvents(`renderAd`, props.containerId);

  const element = document.getElementById(props.containerId);
  const placementElement = element != null && createRoot(element);
  if (placementElement) {
    placementElement.render(
      <AdSwitchComponent key={props.containerId} {...props} />
    );
  }
}
